<template>
  <v-row class="fill-height">
    <v-col class="fill-height">
       <v-card flat height="100%">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="fa-search" label="Search" single-line hide-details />
        </v-card-title>
        <v-data-table :headers="headers" :items="departments" :search="search" v-if="departments">
          <template v-slot:item.name="{ item }">
            <a :href="item.url">{{ item.name }}</a>
          </template>
          <template v-slot:item.email="{ item }">
            <a :href="`mailto:${item.email}`">{{ item.email }}</a>
          </template>
          <template v-slot:item.tel="{ item }">
            <a :href="`tel:${item.tel}`">{{ item.phone }}</a>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Departments',
  data () {
    return {
      headers: [
        { text: 'Department Name', value: 'name' },
        { text: 'Address', value: 'address' },
        { text: 'Email', value: 'email' },
        { text: 'Phone', value: 'phone' },
        { text: 'Fax', value: 'fax' }
      ],
      search: ''
    }
  },
  computed: {
    ...mapGetters([
      'selectedLocation',
      'departments'
    ]),
    ...mapGetters({
      departmentsStore: 'departments'
    }),
    departments () {
      return this.departmentsStore.map(department => {
        return {
          name: department.Name,
          address: department.Location,
          email: department.Email,
          phone: department.Phone,
          tel: department.PhoneInTelFormat,
          fax: department.Fax,
          url: department.Url
        }
      })
    }
  },
  watch: {
    selectedLocation () {
      this.onSelectedLocationChange()
    }
  },
  created () {
    this.onSelectedLocationChange()
  },
  methods: {
    ...mapActions([
      'loadDepartments'
    ]),
    onSelectedLocationChange () {
      if (this.selectedLocation) {
        this.loadDepartments(this.selectedLocation.code)
      }
    }
  }
}
</script>
